import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';
import AudioPlayer from '@backrs_ui/common-ui/src/assets/images/audio-player.png';
import { Box, Typography } from '@mui/material';
export var NuggetAudio = function (_a) {
    var variant = _a.variant;
    if (variant.type === 'LARGE') {
        return (_jsxs(Box, { children: [_jsx(Typography, { sx: bottomTextStyle, variant: "body1", onClick: function () { return window.open(variant.url, '_blank'); }, children: variant.title }), _jsx(Box, { sx: imageContainerStyle, onClick: function () { return window.open(variant.url, '_blank'); }, children: _jsx("img", { src: AudioPlayer, alt: "Audio Player", style: imageStyle }) })] }));
    }
    return (_jsx(Box, { sx: imageContainerStyle, children: _jsx("img", { src: AudioPlayer, alt: "Audio Player", style: imageStyle }) }));
};
var imageContainerStyle = {
    borderRadius: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    width: '100%',
    maxHeight: '450px',
    height: 'auto',
    mt: 3,
    cursor: 'pointer',
};
var imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
};
var bottomTextStyle = {
    fontFamily: 'Sarabun',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20px',
    mt: 2,
    textDecoration: 'underline',
    cursor: 'pointer',
    maxWidth: '100%',
    fontStyle: 'italic',
    color: appColors.color.blue1,
};
